/**
 * Typed references to the colour tokens in `tokens.css`.
 *
 * These are `var(--…)` strings, not literals — the values live in CSS so that
 * stylesheets and components can never drift apart. Use them anywhere a colour
 * is set from TypeScript.
 */
export const color = {
  // Midnight Swim
  midnight: 'var(--color-midnight)',
  midnightDeep: 'var(--color-midnight-deep)',
  bone: 'var(--color-bone)',
  accentBlue: 'var(--color-accent-blue)',

  // Aquarist
  aquaristBg: 'var(--color-aquarist-bg)',
  aquaristPrimary: 'var(--color-aquarist-primary)',
  aquaristDeep: 'var(--color-aquarist-deep)',
  aquaristMuted: 'var(--color-aquarist-muted)',
  aquaristBody: 'var(--color-aquarist-body)',
  aquaristBar: 'var(--color-aquarist-bar)',
  aquaristAccent: 'var(--color-aquarist-accent)',
  aquaristButton: 'var(--color-aquarist-button)',

  // Idle Cafe
  idleCafeNightshade: 'var(--color-idlecafe-nightshade)',
  idleCafeDarkNightshade: 'var(--color-idlecafe-dark-nightshade)',
  idleCafeCream: 'var(--color-idlecafe-cream)',
  idleCafeLightOlive: 'var(--color-idlecafe-light-olive)',
  idleCafeOlive: 'var(--color-idlecafe-olive)',
  idleCafeCustard: 'var(--color-idlecafe-custard)',
  idleCafeParchment: 'var(--color-idlecafe-parchment)',

  // Neutrals
  white: 'var(--color-white)',
  slate: 'var(--color-slate)',
  slateDim: 'var(--color-slate-dim)',

  // Scrims
  scrim: 'var(--color-scrim)',
  panelScrim: 'var(--color-panel-scrim)',
  barScrim: 'var(--color-bar-scrim)',
  accentBorder: 'var(--color-accent-border)',

  /** Resolves to whichever brand the current page is dressed in. */
  brandBg: 'var(--brand-bg)',
  brandInk: 'var(--brand-ink)',
  brandBar: 'var(--brand-bar)',
  brandAccent: 'var(--brand-accent)',
  brandLink: 'var(--brand-link)',
  brandMuted: 'var(--brand-muted)',
  brandMutedDim: 'var(--brand-muted-dim)',
  brandBorder: 'var(--brand-border)',
} as const;

export type ColorToken = keyof typeof color;
